import authClient from "./authClient";

const BASE_URL = process.env.REACT_APP_LIMBO_URL;

class LimboApi {
  fetchIncidents = date => {
    return authClient
      .get(`${BASE_URL}/incidents?date=${date}`)
      .then(response => response.data);
  };

  fetchIncident = incidentId => {
    return authClient
      .get(`${BASE_URL}/incidents/${incidentId}`)
      .then(response => response.data);
  };

  createIncident = incident => {
    return authClient
      .post(`${BASE_URL}/incidents`, incident)
      .then(response => response.data);
  };

  createIncidentUpdate = (incidentId, incidentUpdate) => {
    return authClient
      .post(`${BASE_URL}/incidents/${incidentId}/updates`, incidentUpdate)
      .then(response => response.data);
  };
}

export default LimboApi;



// WEBPACK FOOTER //
// ./src/httpClients/limboApi.js